import { removeSpaces } from "seneca-common/utils/functions";

import { Block, ContentSource } from "../types";
import { TESTABLE_WORD_REGEX } from "./consts";

export function isChemicalEquation(source: ContentSource) {
  return (
    source.shortEquation &&
    source.longEquation &&
    removeSpaces(source.shortEquation) === removeSpaces(source.longEquation)
  );
}

export function canBeMultipleChoiceTested(source: ContentSource) {
  const { wrongAnswers, longEquation } = source;

  return (
    wrongAnswers!.length > 2 && longEquation && !isChemicalEquation(source)
  );
}

export function canBeWordfillTested(source: ContentSource) {
  const { wordsOnly, wordfillSentence } = source;

  const blocks = getBlocks(source);
  const wordfillWords = getWordfillWords(blocks);
  const testableWords = wordfillSentence?.match(
    new RegExp(TESTABLE_WORD_REGEX, "g")
  );

  return (
    !wordsOnly &&
    wordfillWords.length > 0 &&
    !!testableWords &&
    testableWords.length > 0
  );
}

export function getBlocks({ blocks }: ContentSource) {
  return blocks.filter(
    block => block && block.word && block.latexSymbol && block.color
  );
}

export function getWordfillWords(blocks: Block[]) {
  return blocks.map(block => block.word);
}
